import { isTauriRuntime } from './Environment';

export interface KeyValueStorageAdapter {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
}

class MemoryStorageAdapter implements KeyValueStorageAdapter {
  private store = new Map<string, string>();
  getItem(key: string): string | null { return this.store.get(key) ?? null; }
  setItem(key: string, value: string): void { this.store.set(key, value); }
  removeItem(key: string): void { this.store.delete(key); }
}

class BrowserStorageAdapter implements KeyValueStorageAdapter {
  getItem(key: string): string | null { return window.localStorage.getItem(key); }
  setItem(key: string, value: string): void { window.localStorage.setItem(key, value); }
  removeItem(key: string): void { window.localStorage.removeItem(key); }
}

export function getStorageAdapter(): KeyValueStorageAdapter {
  if (typeof window === 'undefined') return new MemoryStorageAdapter();
  if (typeof window.localStorage !== 'undefined') return new BrowserStorageAdapter();
  return new MemoryStorageAdapter();
}

export function getStorageBackendLabel(): string {
  if (typeof window === 'undefined') return 'memory';
  if (isTauriRuntime()) return 'tauri-webview-localStorage';
  if (typeof window.localStorage !== 'undefined') return 'browser-localStorage';
  return 'memory';
}
